import {
    // 批量套用合約版本
    batchContractVersion
    } from "@/apis/company/contractVersion.js";
import {
    getHouseMgtList
    } from "@/apis/company/houseMgt.js";

/*
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'batchContractVersion/set_checkbox_status',
    set_batch_contract_version_list: 'batchContractVersion/set_batch_contract_version_list',
    set_selected_house: 'batchContractVersion/set_selected_house',
    set_instead_loadlord_id: 'batchContractVersion/set_instead_loadlord_id',
    set_instead_group_id: 'batchContractVersion/set_instead_group_id',
    set_instead_sales_id: 'batchContractVersion/set_instead_sales_id',
    set_filter_query: 'batchContractVersion/set_filter_query',
    set_success_list: 'batchContractVersion/set_success_list',
    set_org_group_list: 'batchContractVersion/set_org_group_list',
    set_member_by_group: 'batchContractVersion/set_member_by_group',
}

// count state 必須是 Object
const state = {
    bizBatchContractVersionList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedHouse: [],
    insteadLandlordId: null,
    insteadGroupAndSales: {
        groupId: null,
        agentId: null
    },
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: [],
    organizationGroupList: [],
    memberByGroupList: [],
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BATCH_CONTRACT_VERSION_LIST: (state) => {
        return state.bizBatchContractVersionList
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_LIST_TOTAL: (state) => {
        return state.bizBatchContractVersionList.length
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_SELECTED_HOUSE_CID: (state) => {
        return state.selectedHouse
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_CONTRACT_VERSION_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizBatchContractVersionList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            getHouseMgtList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchDispatch = res.data.result.houseList
                    commit(types.set_batch_contract_version_list, batchDispatch)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizSingleContractVersion ( {commit, dispatch, getters}, data) {
        return new Promise((resolve, reject) => {
            batchContractVersion(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchContractVersionList')
                    dispatch('setAlarmStatus', {status: true,title: '成功套用合約版本',type: 'success'})
                    commit(types.set_success_list)
                    resolve()
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                reject(err)
            })
        })
    },
    setBizBatchContractVersionCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizBatchContractVersionSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setBizBatchContractVersionFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_batch_contract_version_list](state, data){
        state.bizBatchContractVersionList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state, data){
        if(data){
            state.successList = data
        }else{
            state.successList = state.selectedHouse
        }
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/batchContractVersion.js